import { Box, InputBase, styled } from '@mui/material';

export const SearchPanel = styled(Box)({
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  width: 320,
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#f8f9fa',
  borderLeft: '1px solid #d0d0d0',
  boxShadow: '-2px 0 8px rgba(0,0,0,0.1)',
  zIndex: 10,
  overflow: 'hidden',
});

export const SearchInputRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  padding: '8px 10px',
  borderBottom: '1px solid #e0e0e0',
  backgroundColor: '#fff',
});

export const StyledSearchInput = styled(InputBase)({
  flex: 1,
  fontSize: 13,
  backgroundColor: '#fff',
  borderRadius: 4,
  border: '1px solid #d0d0d0',
  padding: '3px 8px',
  minWidth: 0,
  '&.Mui-focused': {
    borderColor: '#1976d2',
    boxShadow: '0 0 0 1px rgba(25,118,210,0.2)',
  },
});

export const SearchResultsContainer = styled(Box)({
  overflow: 'auto',
  flex: 1,
});

export const PageGroupHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  padding: '4px 6px 4px 4px',
  cursor: 'pointer',
  fontSize: 12,
  fontWeight: 600,
  color: '#444',
  backgroundColor: '#eef1f5',
  borderBottom: '1px solid #e0e0e0',
  position: 'sticky',
  top: 0,
  zIndex: 1,
  userSelect: 'none',
  '&:hover': {
    backgroundColor: '#e3e8ee',
  },
});

export const PageGroupCount = styled('span')({
  marginLeft: 'auto',
  fontSize: 10,
  fontWeight: 400,
  color: '#888',
  backgroundColor: '#d8dce2',
  borderRadius: 8,
  padding: '1px 6px',
});

export const SearchResultItem = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 6,
  padding: '4px 8px 4px 24px',
  cursor: 'pointer',
  fontSize: 12,
  lineHeight: 1.5,
  transition: 'background-color 0.1s',
  '&:hover': {
    backgroundColor: '#e8f0fe',
  },
  '&.active': {
    backgroundColor: '#cfe0fc',
  },
});

export const ContextText = styled('span')({
  color: '#666',
  fontSize: 12,
  fontFamily: 'inherit',
  wordBreak: 'break-word',
});

export const MatchText = styled('span')({
  color: '#1a1a1a',
  backgroundColor: '#fff3b0',
  fontWeight: 600,
  fontSize: 12,
  fontFamily: 'inherit',
  borderRadius: 2,
  padding: '0 1px',
});

export const ResultsSummary = styled(Box)({
  padding: '4px 10px',
  fontSize: 11,
  color: '#888',
  borderBottom: '1px solid #e8e8e8',
  backgroundColor: '#f4f5f7',
  flexShrink: 0,
});

export const NoResults = styled(Box)({
  padding: '20px 12px',
  fontSize: 12,
  color: '#888',
  textAlign: 'center',
});
